<template>
    <div class="w-full flex flex-row flex-wrap text-ternary py-4">
        <div class="w-2/3 flex flex-col pr-4">
            <h1 class="text-xl">Welcome to Jobs @ ACTVET Alumni Portal</h1>
            <p class="mt-4">Welcome to the ACTVET JOBS website. Here you can view our current vacancies and find all of
                the information you need about working You can use JOBS to explore the wide range of career
                opportunities available, establish a personal profile, and apply for open positions.</p>
            <p class="mt-8">To ensure that your application is considered in a careful and timely way please:</p>
            <ul class="mt-4 list-disc pl-8">
                <li>Update your profile online.</li>
                <li class="mt-2">Select and apply online for relevant vacancies (ie. those that strongly match your
                    experience, education, and skills).</li>
                <li class="mt-2">Provide all requested supporting documents with your application.</li>
            </ul>
            <p class="mt-8">Thank you for your interest in employment with the ACTVET.
            </p>
        </div>
        <div class="w-1/3 pl-4 flex flex-col">
            <div class="mt-10 h-full w-full flex flex-col border-2 border-secondary rounded-xl p-4 relative">
                <div class="absolute -top-3 px-2 font-bold bg-white ">Latest Postings</div>
                <div v-if="$apollo.queries.getJobOpportunities.loading"
                    class="h-full flex flex-col justify-center items-center">
                    <base-spinner></base-spinner>
                </div>
                <div v-else-if="!$apollo.queries.getJobOpportunities.loading && !hasItems"
                    class="h-full flex justify-center items-center">
                    <h1 class="text-center text-xl font-medium">No vacancies found!</h1>
                </div>
                <ul v-else class="pl-8 pr-8 list-disc text-sm">
                    <li v-for="(item, index) in items" :key="index">
                        <div class="flex">
                            <span @click.stop="openModal(item)"
                                class="text-red-600 mr-1 hover:underline cursor-pointer">{{ item.job_title }} </span>
                            <span class="text-secondary mr-1">advertised</span>
                            <span class="text-red-600">{{ dateInAgo(item.days_ago) }}</span>
                        </div>
                        <div class="text-primary">{{ item.department }}</div>
                    </li>
                </ul>
            </div>
        </div>

        <transition name="fade" mode="out-in">
            <base-modal v-if="isOpenModal"
                :title="`Posting Details - ${selectedItem.job_title} (${selectedItem.partner ? selectedItem.partner.en_company_name : selectedItem.employer_name})`"
                height="" @close="closeModal">
                <apply-job :item="selectedItem" user-type="student" @close="closeModal"></apply-job>
            </base-modal>
        </transition>
    </div>
</template>

<script>
import gql from 'graphql-tag';
import ApplyJob from "./apply-job.vue";
export default {
    name: 'tab- 1',
    components: {
        ApplyJob,
    },
    data() {
        return {
            getJobOpportunities: [],
            first: 10,
            page: 1,
            isOpenModal: false,
            selectedItem: null,
        }
    },
    watch: {
        getJobOpportunities(newVal) {
            if (newVal.error) {
                if (newVal.error_code == 403) {
                    this.$router.replace('/no-permission');
                } else if (newVal.error_code == 401) {
                    this.$router.replace('/');
                } else {
                    alert(newVal.message);
                    this.$router.replace('/');
                }
            }
        },
    },
    computed: {
        items() {
            return this.getJobOpportunities.data;
        },
        hasItems() {
            if (this.items && this.items.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        studentId() {
            return this.$store.getters.student_id;
        },
    },
    apollo: {
        getJobOpportunities() {
            return {
                query: gql`query GetJobOpportunities($first: Int!, $page: Int!, $student_id: String) {
                    getJobOpportunities(first: $first, page: $page, student_id: $student_id) {
                        error
                        error_code
                        message
                        data {
                            id
                            grade_number
                            job_title
                            position_name
                            position_number
                            job_description
                            minimum_qualification
                            preferred_qualification
                            expected_skills
                            special_instructions
                            division
                            department
                            job_start_date
                            job_close_date
                            job_category
                            salary
                            vacancy
                            approved_count
                            rejected_count
                            days_ago
                            benefits
                            job_location
                            working_hours
                            contract_type
                            partner {
                                en_company_name
                            }
                            employer_name
                            job_for
                            student_status
                            program
                            entity
                            campus
                            year_of_study
                            opportunity_type
                        }
                    }
                }`,
                variables() {
                    return {
                        first: this.first,
                        page: this.page,
                        student_id: this.studentId,
                    }
                },
                fetchPolicy: 'cache-and-network'
            }
        },
    },
    methods: {
        dateInAgo(daysAgo) {
            const today = new Date();
            const targetDate = new Date();
            targetDate.setDate(today.getDate() - daysAgo);

            const diffTime = Math.abs(today - targetDate);
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

            if (diffDays === 0) {
                return 'Today';
            } else if (diffDays === 1) {
                return 'Yesterday';
            } else if (diffDays <= 7) {
                return `${diffDays} days ago`;
            } else if (diffDays <= 30) {
                const diffWeeks = Math.floor(diffDays / 7);
                return `${diffWeeks} week${diffWeeks > 1 ? 's' : ''} ago`;
            } else if (diffDays <= 365) {
                const diffMonths = Math.floor(diffDays / 30);
                return `${diffMonths} month${diffMonths > 1 ? 's' : ''} ago`;
            } else {
                const diffYears = Math.floor(diffDays / 365);
                return `${diffYears} year${diffYears > 1 ? 's' : ''} ago`;
            }
        },
        openModal(item) {
            this.selectedItem = item;
            this.isOpenModal = true;
        },
        closeModal() {
            this.isOpenModal = false;
            this.selectedItem = null;
        },
    },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>